module.exports = __webpack_public_path__ + "static/media/ic_ccm_question_selection.c2733d6e.png";